module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4.b19c1719.jpg";